const Ticker = () => {
  const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
  if (!isTouchDevice) return;

  const cards = Array.from(document.querySelectorAll('.cases-hero__card'));
  const carouselLists = Array.from(document.querySelectorAll('.cases-hero__cards-list'));
  if (cards.length === 0 || carouselLists.length === 0) return;

  let activeCard = null;
  let tapTimer = null;
  let tapCount = 0;

  const pauseAnimation = () => {
    carouselLists.forEach(list => {
      list.classList.add('touch-active');
      list.style.animationPlayState = 'paused';
    });
  };

  const resumeAnimation = () => {
    carouselLists.forEach(list => {
      list.classList.remove('touch-active');
      list.style.animationPlayState = 'running';
    });
  };

  const deactivateCurrentCard = () => {
    if (!activeCard) return;
    activeCard.classList.remove('touch-active');
    activeCard = null;
  };

  const onCardClick = (card, event) => {
    if (activeCard === card) {
      return true;
    }

    event.preventDefault();
    tapCount++;

    if (tapCount === 1) {
      tapTimer = setTimeout(() => {
        deactivateCurrentCard();
        pauseAnimation();
        card.classList.add('touch-active');
        activeCard = card;
        tapCount = 0;
      }, 300);
    } else if (tapCount === 2) {
      clearTimeout(tapTimer);
      const href = card.getAttribute('href');
      if (href) window.location.href = href;
      tapCount = 0;
    }
  };

  cards.forEach(card => {
    const readStoryBtn = card.querySelector('.cases-hero__card-read-story');
    const closeBtn = card.querySelector('.cases-hero__card-close-hover-btn');

    card.addEventListener('click', e => onCardClick(card, e));

    if (readStoryBtn) {
      readStoryBtn.addEventListener('click', e => {
        e.stopPropagation();
        const href = card.getAttribute('href');
        if (href) window.location.href = href;
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', e => {
        e.stopPropagation();
        resumeAnimation();
        deactivateCurrentCard();
      });
    }
  });

  document.addEventListener('click', e => {
    if (
      !e.target.closest('.cases-hero__card') &&
      !e.target.closest('.cases-hero__card-carousel-controls')
    ) {
      resumeAnimation();
      deactivateCurrentCard();
    }
  });
};

export default Ticker;